var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-secondary-9 rounded p-3 d-flex justify-content-center align-items-center"
    },
    [
      _c(
        "span",
        { staticClass: "color-secondary-6 font-16 font-weight-normal" },
        [_vm._v(" " + _vm._s(_vm.message) + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }